import { PowerBIReport } from "../components/PowerBIReport";

export const PowerBI = () => {
    return <PowerBIReport
        reportId='0dfe4fb8-224c-4c13-9222-255c086e3b71'
        embedUrl='https://app.powerbi.com/reportEmbed?reportId=0dfe4fb8-224c-4c13-9222-255c086e3b71&ctid=fc406171-ed8a-49b5-8e6c-fcc7f7915c54' />

}